import { ref } from "vue"
import { onSnapshot, queryOrderedSdf1, db, queryOrderedSdf3,collection,query,orderBy, addDoc, serverTimestamp, doc, deleteDoc, updateDoc} from "../main.js"
const getDataFirebase = () => {
    let categories = ref([])
    let errorMessage = ref(null)
    let openEditsTable = ref([])
    let showDetailsTable = ref([])

    let colRef = null
    let queryOrdered = null
    let chosenCollectionName = null
    let docRef = null

    const load = (chosenCollection) => {
        chosenCollectionName = chosenCollection
        colRef = collection(db, chosenCollection)
        queryOrdered = query(colRef, orderBy('createdAt', "asc"))
        
        onSnapshot(queryOrdered, (snapshot)=>{
            try{
                categories.value = []
                openEditsTable.value = []
                snapshot.docs.forEach((doc, i)=>{
                    categories.value.push({...doc.data(), id: doc.id})             
                    openEditsTable.value.push(false)
                    showDetailsTable.value.push([])
                    doc.data().answers.forEach((answer, j) => {
                        showDetailsTable.value[i].push(false)
                    })
            })
            }
            catch(err){
                errorMessage.value = err.message
                console.log(err.message);
            }
        }) 
    }
    const addDocsToDb = async (category, answers, intro) => {
        addDoc(colRef, {            
            category: category.value,
            answers: [...answers.value],
            intro: intro.value,
            createdAt: serverTimestamp()
        })
    }
    const deleteDocFromDb = (id) => {
        try{
            docRef = doc(db, chosenCollectionName, id)
            deleteDoc(docRef)
        }
        catch(err){
            console.log(err.message)
        }
    }
    const deleteAnswerFromDb = (category, id, jindex, answers) => {
        try{
            docRef = doc(db, chosenCollectionName, id)
            const filteredAnswers = answers.filter((answer, j) => {
                return j != jindex
            })
            updateDoc(docRef, {
                category: category,
                answers: filteredAnswers                
            })
        }
        catch(err){
            console.log(err.message)
        }
    }
    const submitEditsToDb = (id, editedCategory, editedAnswers, editedIntro) =>{
        try{
            docRef = doc(db, chosenCollectionName, id)                
            updateDoc(docRef, {
                category: editedCategory.value,
                intro: editedIntro.value,
                answers: editedAnswers.value                  
            })
        }
        catch(err){
            console.log(err.message)
        }
    }
    const addNewAnswerToDb = async (id, category, i, editedAnswers) =>{
        try{
            docRef = doc(db, chosenCollectionName, id)
            editedAnswers.value.push('')
            await updateDoc(docRef, {
                category: category,
                answers: editedAnswers.value
            })
        }
        catch(err){
            console.log(err.message)
        }
        
    }
    return{ categories, openEditsTable, errorMessage, load, addDocsToDb, deleteDocFromDb, deleteAnswerFromDb, submitEditsToDb, addNewAnswerToDb, showDetailsTable }
}  
    
export default getDataFirebase